import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import CommonMessagesPage from "./CommonMessagePage";

const excludeReducers = new Set([
]);


const Notifications = React.memo(() => {
  const store = useSelector((state) => state);

  const messageArray = useMemo(() => {
    const excludeSet = new Set(excludeReducers);

    return Object.entries(store)
      .filter(([sliceName]) => !excludeSet.has(sliceName))
      .map(([sliceName, sliceData]) => ({
        sliceName,
        ...sliceData,
      }));
  }, [store, excludeReducers]);

  return <CommonMessagesPage messageArray={messageArray} />;
});

export default Notifications;